import React from "react";
import useIntegrationsApi from "../integrations/use-integrations-api";

const ActiveIntegrationsContext = React.createContext();
ActiveIntegrationsContext.displayName = "ActiveIntegrationsContext";

const ActiveIntegrationsProvider = (props) => {
    const integrationsApi = useIntegrationsApi();
    const [isIntegrated, setIsIntegrated] = React.useState({});
    const [isInvalid, setIsInvalid] = React.useState({});
    const [isCentrallyManaged, setIsCentrallyManaged] = React.useState({});

    React.useEffect(() => {
        let isGitlabIntegrated = "PENDING";
        let isGitlabSelfManagedIntegrated = "PENDING";
        let isGithubIntegrated = "PENDING";
        let isJiraIntegrated = "PENDING";
        let isNotionIntegrated = "PENDING";
        let isSlackIntegrated = "PENDING";
        let isGoogleIntegrated = "PENDING";
        let isMicrosoftIntegrated = "PENDING";
        let isAzureIntegrated = "PENDING";
        let isMsTeamsIntegrated = "PENDING";

        let gitlabInvalid = false;
        let gitlabSelfManagedInvalid = false;
        let githubInvalid = false;
        let jiraInvalid = false;
        let notionInvalid = false;
        let slackInvalid = false;
        let googleInvalid = false;
        let microsoftInvalid = false;
        let azureInvalid = false;

        let gitlabCentrallyManaged = false;
        let gitlabSelfManagedCentrallyManaged = false;
        let githubCentrallyManaged = false;
        let jiraCentrallyManaged = false;
        let notionCentrallyManaged = false;
        let slackCentrallyManaged = false;
        let googleCentrallyManaged = false;
        let microsoftCentrallyManaged = false;
        let azureCentrallyManaged = false;

        if (integrationsApi && integrationsApi.data) {
            isGitlabIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlab"
            ).connected;

            isGitlabSelfManagedIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlabSelfManaged"
            ).connected;

            isGithubIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "github"
            ).connected;

            isJiraIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "jira"
            ).connected;

            isNotionIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "notion"
            ).connected;

            isSlackIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "slack"
            ).connected;

            isGoogleIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "google"
            ).connected;

            isMicrosoftIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "microsoft"
            ).connected;

            isAzureIntegrated = integrationsApi.data.integrations.find(
                (int) => int.name === "azure"
            ).connected;

            isMsTeamsIntegrated =
                integrationsApi.data.integrations.find((int) => int.name === "msTeams")
                    ?.connected ?? false;

            gitlabInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlab"
            ).invalid;
            gitlabSelfManagedInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlabSelfManaged"
            ).invalid;
            githubInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "github"
            ).invalid;
            jiraInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "jira"
            ).invalid;
            notionInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "notion"
            ).invalid;
            slackInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "slack"
            ).invalid;
            googleInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "google"
            ).invalid;
            microsoftInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "microsoft"
            ).invalid;
            azureInvalid = integrationsApi.data.integrations.find(
                (int) => int.name === "azure"
            ).invalid;

            gitlabCentrallyManaged = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlab"
            ).centrallyManaged;
            gitlabSelfManagedCentrallyManaged = integrationsApi.data.integrations.find(
                (int) => int.name === "gitlabSelfManaged"
            ).centrallyManaged;
            githubCentrallyManaged = integrationsApi.data.integrations.find(
                (int) => int.name === "github"
            ).centrallyManaged;
            jiraCentrallyManaged = integrationsApi.data.integrations.find(
                (int) => int.name === "jira"
            ).centrallyManaged;
            notionCentrallyManaged = integrationsApi.data.integrations.find(
                (int) => int.name === "notion"
            ).centrallyManaged;
            slackCentrallyManaged = integrationsApi.data.integrations.find(
                (int) => int.name === "slack"
            ).centrallyManaged;
            googleCentrallyManaged = integrationsApi.data.integrations.find(
                (int) => int.name === "google"
            ).centrallyManaged;
            microsoftCentrallyManaged = integrationsApi.data.integrations.find(
                (int) => int.name === "microsoft"
            ).centrallyManaged;
            azureCentrallyManaged = integrationsApi.data.integrations.find(
                (int) => int.name === "azure"
            ).centrallyManaged;
        }

        setIsIntegrated({
            gitlab: isGitlabIntegrated,
            gitlabSelfManaged: isGitlabSelfManagedIntegrated,
            github: isGithubIntegrated,
            jira: isJiraIntegrated,
            notion: isNotionIntegrated,
            slack: isSlackIntegrated,
            google: isGoogleIntegrated,
            microsoft: isMicrosoftIntegrated,
            azure: isAzureIntegrated,
            msTeams: isMsTeamsIntegrated,
        });

        setIsInvalid({
            gitlab: gitlabInvalid,
            gitlabSelfManaged: gitlabSelfManagedInvalid,
            github: githubInvalid,
            jira: jiraInvalid,
            notion: notionInvalid,
            slack: slackInvalid,
            google: googleInvalid,
            microsoft: microsoftInvalid,
            azure: azureInvalid,
        });

        setIsCentrallyManaged({
            gitlab: gitlabCentrallyManaged,
            gitlabSelfManaged: gitlabSelfManagedCentrallyManaged,
            github: githubCentrallyManaged,
            jira: jiraCentrallyManaged,
            notion: notionCentrallyManaged,
            slack: slackCentrallyManaged,
            google: googleCentrallyManaged,
            microsoft: microsoftCentrallyManaged,
            azure: azureCentrallyManaged,
        });
    }, [integrationsApi?.data && JSON.stringify(integrationsApi.data)]);

    const value = React.useMemo(
        () => ({
            activeIntegrations: integrationsApi,
            isIntegrated,
            isInvalid,
            isCentrallyManaged,
        }),
        [integrationsApi, isIntegrated, isInvalid, isCentrallyManaged]
    );

    return <ActiveIntegrationsContext.Provider value={value} {...props} />;
};

const useActiveIntegrations = () => {
    const context = React.useContext(ActiveIntegrationsContext);
    if (context === undefined) {
        throw new Error(`useActiveIntegrations must be used within a ActiveIntegrationsProvider`);
    }
    return context;
};

export { ActiveIntegrationsProvider, useActiveIntegrations };
